import { downloadFile } from "../../api" 

export const createSessionSlice = (set, get) => ({
  // Session state
  currentSessionId: null,


  sessions: [],
  sessionHistory: [], // Array of {prompt, output, timestamp} objects

  fetchSessions: async () => {

    const response = await fetch('/api/esper/session', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })


    if (response.ok) {
      const data = await response.json()
      console.log('set sessions', data.sessions)
      set({
        sessions: data.sessions,
      })
      return data.sessions
    } else {
      set({
        sessions: []
      })
      return []
    }
  },
  

  loadSession: async (sessionId) => {
    const response = await fetch('/api/esper/session/' + String(sessionId) + '/chat', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
    if (response.ok) {
      const data = await response.json()
      console.log('loaded', data)

      if (data.messages.length == 0) {
        // tricky part. User may have uploded an image, but never interacted with it. 
        if (data.initial_data) {
          const dataPartsRes = await fetch('/api/data/' + String(data.initial_data) + '/parts', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          })
          const dataParts = await dataPartsRes.json()
          let originalImage = await downloadFile(dataParts.parts.at(-1))
          let currentImage = originalImage

          let sessionHistory = [{
            currentDataId: dataParts.parts.at(-1),
            currentAuxDataId: null,
          }]
          let imageHistory= [{
            image: currentImage, 
            description: 'Original image', title: 'Original image', pinned: false, timestamp: data.created	
          }]
          return set({
            sessionHistory,
            imageHistory,
            originalImage,
            currentImage,
            currentSessionId: sessionId,
            chatHistory: [],
          })
        } else {
          return set({
            sessionHistory: [],
            chatHistory: [],
            originalImage: null,
            currentImage: null,
            imageHistory: [],
            currentSessionId: sessionId,
          })
        }
      }

      let imagesMap = data.messages.map((e) => downloadFile(e.input_data)).concat([downloadFile(data.messages.at(-1).output_data)])
      let uploaded = await Promise.all(imagesMap)

      let chatHistory = []
      let sessionHistory = []
      let imageHistory = []
      let originalImage = uploaded[0]
      
      let currentImage = null

      for (let i = 0; i < data.messages.length; i++) {
        sessionHistory.push({
          currentDataId: data.messages[i].input_data,
          currentAuxDataId: data.messages[i].input_aux_data,
        })

        chatHistory.push({
          type: 'user',
          content: data.messages[i].message,
          timestamp: data.messages[i].created	
        })

        chatHistory.push({
          type: 'ai',
          content: data.messages[i].response,
          timestamp: data.messages[i].created	
        })

        

        if (i == 0) {
          if (uploaded[0]) {
            imageHistory.push({
              image: uploaded[0], 
              description: 'Original image', title: 'Original image', pinned: false, timestamp: data.messages[i].created	
            })
          }
        } else{ 
          if (!originalImage) {
            originalImage = uploaded[i]
            imageHistory.push({
              image: uploaded[i], 
              description:  data.messages[i - 1].message, title:  data.messages[i - 1].message, pinned: false, timestamp: data.messages[i].created	
            })
          } else {
            imageHistory.push({
              image: uploaded[i], 
              description:  data.messages[i - 1].message, title:  data.messages[i - 1].message, pinned: false, timestamp: data.messages[i].created	
            })
          }
        }
      }

      sessionHistory.push({
        currentDataId: data.messages.at(-1).output_data,
        currentAuxDataId: null
      })

      currentImage = uploaded.at(-1)

      imageHistory.push({
        image: currentImage, 
        description:  data.messages.at(-1).message, title:  data.messages.at(-1).message, pinned: false, timestamp: data.messages.at(-1).created	
      })


      return set({
        sessionHistory: sessionHistory,
        chatHistory: chatHistory,
        originalImage: originalImage,
        currentImage: currentImage,
        imageHistory: imageHistory,
        currentSessionId: sessionId,
      })

    } else {
      return 
    }
  },

  deleteSession: async (sessionId) => {
    if (sessionId) {
      const response = await fetch("/api/esper/session/" + String(sessionId), {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
    }


    return set((state) => ({
      sessions: state.sessions.filter((e) => e.id != sessionId),
      currentSessionId: (state.currentSessionId == sessionId) ? null : state.currentSessionId,
      sessionHistory:  (state.currentSessionId == sessionId) ? [] : state.sessionHistory,
      chatHistory:  (state.currentSessionId == sessionId) ? [] : state.chatHistory,
      originalImage:  (state.currentSessionId == sessionId) ? null : state.originalImage,
      currentImage:  (state.currentSessionId == sessionId) ? null : state.currentImage,
      imageHistory:  (state.currentSessionId == sessionId) ? [] : state.imageHistory,
    }))
  },

  createSession: async (initialData) => {
    const response = await fetch('/api/esper/session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        initial_data: initialData,
      })
    })

    if (response.ok) {
      const data = await response.json()
      console.log('Created new session', data)

      return set((state) => ({
        sessions: [...state.sessions, data],
        currentSessionId: data.id,

        sessionHistory: [],
        chatHistory: [],
        currentImage: null,
        originalImage: null,
        imageHistory: [],
        
        currentImage: null,
      }))

    } else {
      set({      
        sessionHistory: [],
        chatHistory: [],
        currentImage: null,
        originalImage: null,
        imageHistory: [],
        
        currentSessionId: null,
        currentImage: null,
      })
      return { success: false }
    }
  },

  setInitialData: async (initialData) => {
    const response = await fetch('/api/esper/session/' + String(get().currentSessionId), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        initial_data: initialData,
      })
    })

    if (response.ok) {
      const data = await response.json()
      return { success: true}
    } else {
      return { success: false }
    }
  },

  setSessionData: async (thumbnailDataId, auxDataId) => {
    return set((state) => ({
      sessionHistory: [{
        currentDataId: thumbnailDataId, // << 
        currentAuxDataId: auxDataId,
      }],
    }))
  },


  appendCurrentData: async (thumbnailDataId, auxDataId) => {
    return set((state) => ({
      sessionHistory: [...state.sessionHistory, {
        currentDataId: thumbnailDataId, // << 
        currentAuxDataId: auxDataId,
      }],
    }))
  },

  removeLastFromSession: async () => {
    const response = await fetch('/api/esper/session/' + String(get().currentSessionId) + '/chat', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
    if (response.ok) {
      let imageHistory = get().imageHistory
      imageHistory.pop()

      let sessionHistory = get().sessionHistory
      sessionHistory.pop()

      let chatHistory = get().chatHistory
      chatHistory.pop()
      chatHistory.pop()

      console.log('removeLastFromSession', sessionHistory, imageHistory, chatHistory)
      return set((state) => ({
        sessionHistory: sessionHistory,

        chatHistory: chatHistory,
        imageHistory: imageHistory,
        currentImage: imageHistory[imageHistory.length-1].image,
      }))
    }
  }
})